import { decode } from 'html-entities'
import * as i18next from 'i18next'
import * as React from 'react'
import { AsyncState, fromJSX, Option, Updater, Widget } from 'widgets-for-react'
import { parseImageUrl } from '../../drupal/rendering/image_utils.mod'
import { ParsedMenuItem } from '../../drupal/types_and_parser/extra_types.mod'
import { ParsedConfigPagesFooter } from '../../drupal/types_and_parser/types.ext.gen'
import { ExternalLink } from '../utils/external_link'
import { defaultLanguage, getLangFromUrl } from '../utils/history.mod'

export type FooterState = {
  cols: AsyncState<Array<ParsedMenuItem>>
  col_1: Option<ParsedMenuItem>
  col_2: Option<ParsedMenuItem>
  col_3: Option<ParsedMenuItem>
  privacyMenu: AsyncState<Array<ParsedMenuItem>>
  footerImage: AsyncState<ParsedConfigPagesFooter>
}

export const footer: (_: FooterState, show_cookiebar: () => void, inert: boolean) => Widget<Updater<FooterState>> = (
  props,
  show_cookiebar,
  inert
) => {
  return fromJSX(() => {
    // return (
    //   <Footer>
    //     <div className="footer__inner ls-container">
    //       <div className="footer__logo">
    //         <Link to={addLangToUrl('/')}>
    //           <img src="/frontend/images/logo--tagline.svg" alt={`${sitename}'s logo`} />
    //         </Link>
    //       </div>
    //       <nav className="nav nav--footer">
    //         {/* Quicklinks */}
    //         {props.menu.kind == 'loaded' && (
    //           <ul className="nav__list" id="a11y-footer-navigation">
    //             {props.menu.value.map((menuItem) => (
    //               <li className="nav__item">
    //                 {menuItem.url && (
    //                   <ExternalLink
    //                     type="link"
    //                     className="nav__link"
    //                     to={menuItem.url}
    //                   >
    //                     {menuItem.label}
    //                   </ExternalLink>
    //                 )}
    //               </li>
    //             ))}
    //           </ul>
    //         )}
    //       </nav>
    //       <div className="footer__copyright"  id="a11y-footer-copyright">
    //           {/* Quicklinks */}
    //           {props.privacyMenu.kind == 'loaded' && (
    //             <ul className="nav__list" id="a11y-footer-navigation">
    //               <li className="nav__item nav__item--opace">
    //               {i18next.t("footer:copyright")}
    //               </li>
    //               {props.privacyMenu.value.map((privacyItem) => (
    //                 <li className="nav__item nav__item--opace">
    //                   {privacyItem.url && (
    //                     <ExternalLink
    //                       type="link"
    //                       className="nav__link"
    //                       to={privacyItem.url}
    //                     >
    //                       {privacyItem.label}
    //                     </ExternalLink>
    //                   )}
    //                 </li>
    //               ))}
    //               <li className="nav__item nav__item--social">
    //                 <h2 className="footer__title text--l">{i18next.t("footer:linkedin_text")}</h2>
    //                 <a className="footer__social-link"  href={i18next.t("footer:linkedin_link")}></a>
    //               </li>
    //             </ul>
    //           )}
    //       </div>
    //     </div>
    //   </Footer>
    // )
    const col_1 = props.col_1.kind == 'r' ? getDrupalUlMenu(props.col_1.v, props.col_1.v.children || []) : null
    const col_2 = props.col_2.kind == 'r' ? getDrupalUlMenu(props.col_2.v, props.col_2.v.children || []) : null
    const col_3 = props.col_3.kind == 'r' ? getDrupalUlMenu(props.col_3.v, props.col_3.v.children || []) : null
    const privacy = props.privacyMenu.kind == 'loaded' ? getDrupalUlMenu(undefined, props.privacyMenu.value) : null
    return (
      <Footer inert={inert}>
        <div className="footer__inner">
          <div className="footer__top">
            <div className="footer__inner ls-container">
              <div className="footer__logo">
                <a href="/">
                  <img
                    loading="lazy"
                    src="/frontend/images/sprites/logos.svg#white"
                    alt={`${sitename}'s logo`}
                    width="150"
                    height="50"
                  />
                </a>
              </div>
              <nav className="nav nav--footer">
                {col_1 && ul_menu(col_1)}
                {col_2 && ul_menu(col_2)}
                {col_3 && ul_menu(col_3)}
              </nav>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="footer__inner ls-container">
              {defaultLanguage != 'ru' && (
                <div className="footer__cta">
                  <div className="footer__link text--s">
                    <p>{i18next.t('Footer:Newsletter:SignUpText')}</p>
                    <a className="link text--l" href={i18next.t('Footer:Newsletter:SignUplink')}>
                      {i18next.t('Footer:Newsletter:SignUpLinkText')}
                    </a>
                  </div>
                  <div className="footer__visual fit-object">
                    <img
                      alt="Magazine"
                      loading="lazy"
                      src={
                        props.footerImage.kind == 'loaded'
                          ? parseImageUrl(props.footerImage.value.field_image.image.url)
                          : ''
                      }
                    />
                  </div>
                </div>
              )}
              <div className="footer__content">
                <div className="footer__social social">
                  <ul className="social__list">
                    {defaultLanguage != 'ru' && (
                      <li className="social__item">
                        <a
                          className="social__link social__link--linkedin"
                          aria-label="linkedin"
                          href={'https://www.linkedin.com/company/van-oord/'}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg aria-hidden="true" width="24" height="24">
                            <use xlinkHref="#icon--linkedin" />
                          </svg>
                        </a>
                      </li>
                    )}
                    <li className="social__item">
                      <a
                        className="social__link social__link--facebook"
                        aria-label="facebook"
                        href={'https://www.facebook.com/VanOordDMC'}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg aria-hidden="true" width="24" height="24">
                          <use xlinkHref="#icon--facebook" />
                        </svg>
                      </a>
                    </li>
                    <li className="social__item">
                      <a
                        className="social__link social__link--instagram"
                        aria-label="instagram"
                        href={'https://www.instagram.com/vanoord_official/'}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg aria-hidden="true" width="24" height="24">
                          <use xlinkHref="#icon--instagram" />
                        </svg>
                      </a>
                    </li>
                    <li className="social__item">
                      <a
                        className="social__link social__link--vimeo"
                        aria-label="vimeo"
                        href={'https://vimeo.com/vanoord'}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg aria-hidden="true" width="24" height="24">
                          <use xlinkHref="#icon--vimeo" />
                        </svg>
                      </a>
                    </li>
                    <li className="social__item">
                      <a
                        className="social__link social__link--youtube"
                        aria-label="youtube"
                        href={'https://www.youtube.com/c/VanOordDMC'}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg aria-hidden="true" width="24" height="24">
                          <use xlinkHref="#icon--youtube" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
                <nav className="nav nav--copyright">
                  {privacy &&
                    ul_menu(
                      privacy,
                      <button className="nav__link nav__link--cookie deprecated-link--chevron" onClick={show_cookiebar}>
                        {i18next.t('Footer:CookieManage')}
                      </button>
                    )}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </Footer>
    )
  })
}

type UlMenuProps = { label?: string; items: Array<{ url: string; label: string }> }

const getDrupalUlMenu = (parent: ParsedMenuItem | undefined, list: Array<ParsedMenuItem>): UlMenuProps => ({
  label: parent && parent.label,
  items: list.map((item) => ({ url: item.url, label: item.label }))
})

type VacancyPreview = {
  id: number
  title: string
  description: string
  postedAt: string
  matchIds: number[]
}

const ul_menu = (props: UlMenuProps, extra_item?: JSX.Element): JSX.Element => (
  <ul className="nav__list text--s">
    {props.label && (
      <li className="nav__item">
        <p className="nav__title title--s">{props.label}</p>
      </li>
    )}
    {props.items.map((menuItem) =>
      !menuItem.label.toLowerCase().includes('rss') ? (
        <li className="nav__item">
          {menuItem.url && (
            <ExternalLink type="link" className="nav__link deprecated-link--chevron" to={menuItem.url}>
              {' '}
              {decode(menuItem.label)}
            </ExternalLink>
          )}
        </li>
      ) : (
        <li className="nav__item">
          <a className="nav__link deprecated-link--chevron" href={`/${getLangFromUrl()}${menuItem.url}`}>
            {decode(menuItem.label)}
          </a>
        </li>
      )
    )}
    {extra_item ? <li className="nav__item"> {extra_item} </li> : <></>}
  </ul>
)

const Footer = (props: { inert: boolean; children: React.ReactNode }) => {
  return (
    <footer id="a11y-footer" className="footer" inert={props.inert ? '' : undefined}>
      {props.children}
    </footer>
  )
}
